import script from "./SocialConnect.vue?vue&type=script&lang=ts&setup=true"
export * from "./SocialConnect.vue?vue&type=script&lang=ts&setup=true"

import "./SocialConnect.vue?vue&type=style&index=0&id=e276bc5e&lang=sass"

const __exports__ = script;

export default __exports__